<template>
  <v-card
    :loading="loading"
    class="mx-auto my-1 elevation-4"
    block
    outlined
    color="#FAFAFA">
    <v-img
      width="100%"
      contain
      :src=userad.imageURL
    ></v-img>

    <v-card-title>{{ userad.postedBy }}</v-card-title>

    <v-card-text>
      <v-row
        align="center"
        class="mx-0"
      >
        <v-rating
          :value="userad.rating"
          color="purple accent-3"
          dense
          half-increments
          readonly
          size="14"
        ></v-rating>

        <div class="grey--text ml-4">{{ userad.rating }} ({{ userad.allTimeJobs }})</div>
      </v-row>
      <v-chip-group 
      multiple 
      column 
      v-model="igigs"
      active-class="purple accent-3">
      <v-chip small v-for="gig in userad.gigs" :key="gig">
        {{ gig }}
      </v-chip>
      </v-chip-group>

      {{ userad.introduction }}
    </v-card-text>

    <v-divider class="mx-4"></v-divider>
    <v-card-title>
        <v-icon mr-5>mdi-home-group</v-icon>
        <v-chip-group  
          column 
          max="1"
          v-model="ihood"
          active-class="purple accent-3">
      <v-chip small v-for="hood in userad.hoods" :key="hood">
        {{ hood }}
      </v-chip>
      </v-chip-group>
      <v-spacer></v-spacer>
      <v-icon>mdi-city</v-icon>
      <v-chip
      color="purple accent-3"
      text-color="dark"
      small
      >{{ userad.city}}</v-chip>
      <!-- <span class="subtitle-2">{{ userad.city }}</span> -->
    </v-card-title>
    <v-card-actions>
      <v-btn
      color="purple accent-3"
      icon
      text
      @click="connectPhone(userad.phone,userad.postedBy)"
      >
      <v-icon large>mdi-phone-outgoing</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
      text 
      icon        
      color="purple accent-3"
      @click="connectText"
      >
      <v-icon large>mdi-message</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
      text 
      icon        
      color="purple accent-3"
      @click="connectRate"
      >
      <v-icon large>mdi-thumb-up</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
      text 
      icon        
      color="purple accent-3"
      @click="connectReport"
      >
      <v-icon large>mdi-cancel</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
    props: ['userad'],
    data() {
      return {
        loading: false,
        igigs: [],
        ihood: null,
      }
    },
    methods: {
      connectPhone() {
        // eslint-disable-next-line no-console
        // console.log("Call ",this.userad.phone," to talk to ",this.userad.postedBy)
        alert('Call ' + this.userad.phone + " to talk to " + this.userad.postedBy)
      },
      connectText() {},
      connectRate() {},
      connectReport() {},
    },
    computed: {
      
    },
    updated() {
      // eslint-disable-next-line no-console
      // console.log('inquiry jobs : ',this.igigs,' inquiry hoods : ',this.ihood)
    }
}
</script>